// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/** The consumer Budget Guide (Guide Center article). One path, referenced by the
 * Budget settings link, the hub index and the mobile Guide Center row. */
export const BUDGET_GUIDE_PATH = "/guides/how-your-grocery-budget-works"
export const BUDGET_GUIDE_URL = `https://bitebalance.de${BUDGET_GUIDE_PATH}`
